import { useRecoilTransaction_UNSTABLE } from "recoil"

import { designLocalState } from "~/containers/Proposal/state/designs/design-state"

import type { TransactionOperation } from ".."
import { findNodeState } from "../../nodes"
import { getNodeSelectionState, nodeSelectionState } from "../../nodeSelection"
import { findPanelState, panelSelectionState } from "../../panels"
import { areasOfPanelsIndexState } from "../../relations"
import type {
  IncompleteUnknownAction,
  NodeActionTo_,
  PanelActionTo_,
  UnknownActionForUnknownElement,
} from "../../timeline"
import { findNewRelationActionsState, findNewActionsState } from "../../timeline"

export const startMove: TransactionOperation = (transactors) => {
  const { get, set } = transactors
  const nodeSelection = getNodeSelectionState(transactors)
  const panelSelection = get(panelSelectionState)
  const nodeIds = Array.from(nodeSelection)
  const panelIds = Array.from(panelSelection)
  const nodeActions: UnknownActionForUnknownElement[] = nodeIds.map(
    (id): NodeActionTo_[`UPDATE`] => ({
      type: `UPDATE`,
      family: `NODE`,
      id,
      payload: get(findNodeState(id)),
    }),
  )
  const panelActions: UnknownActionForUnknownElement[] = panelIds.map(
    (id): PanelActionTo_[`UPDATE`] => ({
      type: `UPDATE`,
      family: `PANEL`,
      id,
      payload: get(findPanelState(id)),
    }),
  )
  const areaPanelRelationActions: IncompleteUnknownAction[] = panelIds.map(
    (panelId): IncompleteUnknownAction => {
      const areasOfPanelsIndex = get(areasOfPanelsIndexState)
      const areaId = areasOfPanelsIndex.from(panelId)

      return {
        type: areaId ? `ATTACH` : `DETACH`,
        family: `AREA_PANEL`,
        id: areaId,
        relatedId: panelId,
      }
    },
  )
  const newActions = [...nodeActions, ...panelActions]
  const { phase } = get(designLocalState)
  const newActionsState = findNewActionsState(phase)
  const newRelationActionsState = findNewRelationActionsState(phase)
  set(newActionsState, newActions)
  set(newRelationActionsState, areaPanelRelationActions)
}

export const useStartMove = (): VoidFunction =>
  useRecoilTransaction_UNSTABLE((transactors) => () => {
    startMove(transactors)
  })
